<template>
  <article class="solic-card-skeleton">
    <section class="header-section">
      <div
        class="d-flex align-center"
        style="gap: 15px;"
      >
        <v-skeleton-loader
          type="text"
          width="120"
        />
        <v-skeleton-loader
          type="chip"
          width="100"
        />
      </div>
      <div class="d-flex align-center gap-2">
        <v-skeleton-loader
          type="text"
          width="300"
        />
      </div>
    </section>
    <div class="separator"></div>
    <section class="card-content">
      <div class="route-section">
        <v-skeleton-loader
          type="text"
          width="60"
          class="mb-2"
        />
        <div class="timeline-skeleton">
          <div
            class="d-flex align-center"
            style="gap: 10px; margin-bottom: 16px;"
          >
            <v-skeleton-loader
              type="avatar"
              width="12"
              height="12"
            />
            <v-skeleton-loader
              type="text"
              width="150"
            />
          </div>
          <div
            class="d-flex align-center"
            style="gap: 10px;"
          >
            <v-skeleton-loader
              type="avatar"
              width="12"
              height="12"
            />
            <div
              class="d-flex flex-column"
              style="gap: 5px;"
            >
              <v-skeleton-loader
                type="text"
                width="180"
              />
              <v-skeleton-loader
                type="text"
                width="220"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <v-skeleton-loader
            type="text"
            width="80"
            class="mb-2"
          />
          <v-skeleton-loader
            type="text"
            width="120"
          />
        </div>
        <div class="info-item">
          <v-skeleton-loader
            type="text"
            width="80"
            class="mb-2"
          />
          <v-skeleton-loader
            type="text"
            width="100"
          />
        </div>
        <div class="info-item">
          <v-skeleton-loader
            type="text"
            width="80"
            class="mb-2"
          />
          <v-skeleton-loader
            type="text"
            width="130"
          />
        </div>
        <div class="info-item">
          <v-skeleton-loader
            type="text"
            width="80"
            class="mb-2"
          />
          <v-skeleton-loader
            type="text"
            width="90"
          />
        </div>
      </div>
      <div class="action-section">
        <v-skeleton-loader
          type="avatar"
          width="40"
          height="40"
        />
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'TransportSolicCardSkeleton',
}
</script>

<style scoped>
.solic-card-skeleton {
  color: #E7E3FC;
  display: flex;
  gap: 16px;
  flex-direction: column;
  border-radius: 10px;
  padding: 15px 48px 26px 38px;
  border-left: 11px solid #E7E3FC1A;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.separator {
  height: 1px;
  width: 100%;
  background-color: #534D74;
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.route-section {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.timeline-skeleton {
  display: flex;
  flex-direction: column;
}

.info-grid {
  flex: 0 0 300px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-section {
  flex: 0 0 60px;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
}

@media (max-width: 1400px) {
  .action-section {
    flex: 0 0 50px;
  }

  .info-grid {
    flex: 0 0 280px;
  }

  .route-section {
    flex: 0 0 320px;
  }
}

@media (max-width: 1340px) {
  .action-section {
    flex: 0 0 30px;
  }

  .header-section {
    flex-direction: column;
    gap: 10px;
  }

  .info-grid {
    flex: 0 0 250px;
  }

  .route-section {
    flex: 0 0 300px;
  }
}

@media (max-width: 1220px) {
  .card-content {
    flex-direction: column;
    gap: 16px;
  }

  .route-section,
  .info-grid,
  .action-section {
    flex: none;
    width: 100%;
  }

  .info-grid {
    gap: 12px;
  }

  .action-section {
    justify-content: flex-end;
    padding-top: 8px;
    height: auto;
  }
}
</style>
